import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { Auth } from './Auth';
import { endpoints } from '../../environments/environment';

@Injectable()
export class OAuthTokenService {

  constructor(private http: HttpClient) { }

  auth(cpf: string, pass: string): Observable<any> {
    const URL = endpoints.auth.oauth;
    const payload = new HttpParams()
      .set('grant_type', 'password')
      .set('username', cpf)
      .set('password', pass);

    const basicOAuth = endpoints.basicOAuth;

    const headers = new HttpHeaders({
      Authorization: `Basic ${basicOAuth}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post(URL, payload.toString(), { headers }).pipe(map((data: any) => {
      return data;
    }));
  }

  selectAccount(token): Observable<any> {
    const URL = endpoints.auth.oauth;
    const {accountNumber, agency } = Auth.getInstance().getUser();

    const payload = new HttpParams()
      .set('grant_type', 'account_select')
      .set('refresh_token', token)
      .set('numero_agencia', agency.toString())
      .set('numero_conta', accountNumber)

    const basicOAuth = 'b21uaWRpZ2l0YWw6c2VjcmV0';

    const headers = new HttpHeaders({
      Authorization: `Basic ${basicOAuth}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post(URL, payload.toString(), { headers }).pipe(map((data: any) => {
      sessionStorage.setItem('_OmniBearerRefreshV2', data.refresh_token);
      sessionStorage.setItem('_OmniBearerV2', data.access_token);
      return data;
    }));
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/o-auth-token.service.ts